import React, { useEffect, useState, useCallback } from "react";
import { RefreshCw } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Self-contained challenge widget. Calls onChange({ captcha_id, captcha_answer })
// whenever the challenge or the typed answer changes.
export function Captcha({ onChange, inputClass = "", label = "Type the characters above" }) {
  const [img, setImg] = useState(null);
  const [cid, setCid] = useState(null);
  const [ans, setAns] = useState("");
  const [loading, setLoading] = useState(false);

  const load = useCallback(async () => {
    setLoading(true);
    setAns("");
    try {
      const r = await fetch(`${API}/captcha/new`);
      const d = await r.json();
      setImg(d.image);
      setCid(d.captcha_id);
      onChange && onChange({ captcha_id: d.captcha_id, captcha_answer: "" });
    } catch (e) {
      /* ignore */
    } finally {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => { load(); }, [load]);

  const upd = (v) => {
    setAns(v);
    onChange && onChange({ captcha_id: cid, captcha_answer: v });
  };

  return (
    <div className="space-y-2" data-testid="captcha-widget">
      <div className="flex items-center gap-2">
        {img ? (
          <img src={img} alt="verification challenge" data-testid="captcha-image"
               className="rounded-md border border-white/15 h-[88px] w-[256px] object-contain bg-white" />
        ) : (
          <div className="rounded-md border border-white/15 h-[88px] w-[256px] bg-white/5 animate-pulse" />
        )}
        <button type="button" onClick={load} disabled={loading} data-testid="captcha-refresh"
                title="New challenge" className="p-2 rounded-md hover:bg-white/10 text-muted-foreground">
          <RefreshCw size={16} className={loading ? "animate-spin" : ""} />
        </button>
      </div>
      <input value={ans} onChange={(e) => upd(e.target.value)} data-testid="captcha-input"
             autoCapitalize="characters" autoComplete="off" placeholder={label} className={inputClass} />
    </div>
  );
}

export default Captcha;
